<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" *ngIf="showSideMenu">
            <a routerLink="/naac/ssr/criteria4"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>4.3</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <!-- <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria4/4-3/4-3-1" (click)="checkRoute()">4.3.1</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria4/4-3/4-3-2" (click)="checkRoute()">4.3.2</a>
                    </li> -->
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>